module.exports = __webpack_public_path__ + "img/es.8c819b2f.png";